import { z } from "zod";

/**
 * validateEmail
 * Validates an email address using Zod schema validation
 * @param email The email address to validate
 * @returns boolean indicating if email is valid
 */
export function validateEmail(email: string): boolean {
    const emailSchema = z.email();
    const result = emailSchema.safeParse(email);
    return result.success;
}
